// Door Ranges — admin portal mount.
//
// Same editor the supplier portal uses (@tkos/door-range-builder), mounted in
// "admin" scope so Steve can maintain a supplier's catalogue on its behalf.
// That is the near-term operating model: real suppliers will not author their
// own ranges, so the platform operator does it for them.
//
// The only difference from the supplier mount is the supplier picker, which
// reads /api/admin/supplier-directory (PG `suppliers` merged with the
// file-store accounts). Ranges saved here are attributed to the CHOSEN
// supplier, with authoredBy:"admin" recorded as provenance — so a supplier
// that later signs in to self-serve finds its own catalogue already populated
// and editable, with no migration.

// The supplier picker's "+ Add new supplier" entry hands off to Suppliers
// (Admin) rather than growing a second creation form here. That page owns the
// real record — name, slug, contact, brand colour — and its POST writes the PG
// `suppliers` reference entity that this builder then keys ranges off by slug.

import { createDoorRangeBuilderPage } from "@tkos/door-range-builder";
import { navigate, registerPage } from "../../shell/router";
import type { Page } from "../../shell/types";

const doorRangesPage: Page = createDoorRangeBuilderPage({
  scope: { kind: "admin" },
  label: "Door Ranges",
  icon: "🚪",
  onAddSupplier: () => navigate("suppliers"),
});

registerPage(doorRangesPage);

export default doorRangesPage;
